export default __webpack_public_path__ + "static/media/logo.042692c0.png";